import { Box } from '../../Box';
import { keyGen } from '../../internal/utils/keyGen';
import { resolveChipPadding } from './ComboBoxMultiSelect';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { readOnlyChip } from './ReadOnlyChip';
import { idBuilder } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
const buildChips = (selectedOptions, theme, id, dataTestId) => {
  return selectedOptions.map((o, index) => /*#__PURE__*/_jsx(Box, {
    sx: readOnlyChip(theme),
    id: idBuilder('ids-comboBox-read-only-chip', id, index),
    "data-testid": idBuilder('ids-comboBox-read-only-chip', dataTestId, index),
    className: 'ids-comboBox-read-only-chip',
    children: o.label
  }, keyGen()));
};
const resolveStyle = size => ({
  display: 'flex',
  padding: `${resolveChipPadding(size)} 0`,
  alignItems: 'center',
  alignContent: 'center',
  gap: '4px',
  flex: '1 0 0',
  alignSelf: 'stretch',
  flexWrap: 'wrap'
});
export const ReadOnlyMultiple = props => {
  const {
    size,
    selectedOptions,
    id,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const style = resolveStyle(size);
  const _chips = selectedOptions && selectedOptions.length > 0 ? buildChips(selectedOptions, theme, id, rest['data-testid']) : '\u2014';
  return /*#__PURE__*/_jsx(Box, {
    className: 'ids-combobox-read-only-multiple',
    sx: style,
    id: idBuilder('ids-comboBox-read-only-multiple', id),
    "data-testid": idBuilder('ids-comboBox-read-only-multiple', rest['data-testid']),
    children: _chips
  });
};